import {
  compose,
  pure,
  withProps,
  lifecycle
} from 'recompose'
import { connect } from 'react-redux'
import {
  reduxForm,
  formValueSelector
} from 'redux-form'
import _pick from 'lodash/pick'

import {
  getUserData,
  accountUpdate,
} from '../reducers/user'
import { getLoginHistory } from '../reducers/login-history'
import Account from '../components/Account'
import { scrollToFirstError } from '../lib/validation'
import {
  loadLoginHistoryHandler,
  loadOrdersHistoryHandler,
  tabSelectHandler,
  accountFormSubmitHandle,
  isAuthenticated,
  withInitialData
} from '../components/hoc'

const mapStateToProps = (state, ownProps) => {
  const formSelector = formValueSelector('account')
  const selectedCountry = formSelector(state, 'address.country') || ''
  const userData = ownProps.user || state.user

  return {
    user: state.user.details,
    loading: state.user.loading,
    initialValues: {
      user: _pick(userData.details, [
        'id',
        'first_name',
        'last_name',
        'phone',
        'opt_in_email'
      ]),
      address: _pick(userData.address, [
        'id',
        'business_name',
        'address1',
        'address2',
        'country',
        'state',
        'city',
        'zip'
      ])
    },
    subscriptions: _pick(userData.details, [
      'sub_exp_date',
      'reprog_exp_date',
      'mdars_exp_date',
      'training_exp_date',
      'pats_exp_date',
      'ids_exp_date'
    ]),
    isAuthenticated: state.user.isAuthenticated,
    language: state.cookies.lang,
    countries: state.global.regions.country.list,
    regions: state.global.regions.byCountry[selectedCountry] || [],
    loginHistoryList: state.loginHistory.list,
    loginHistoryPageCount: state.loginHistory.pages,
    loginHistoryCurrentPage: state.loginHistory.currentPage,
    loginHistoryItemsPerPage: 10,
    ordersList: state.orders.list,
    ordersPageCount: state.orders.pages,
    ordersCurrentPage: state.orders.currentPage,
    ordersItemsPerPage: 1,
    isOrdersListLoading: state.orders.loading,
    cart: state.cart
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getUserData: () => dispatch(getUserData()),
    accountUpdate: data => dispatch(accountUpdate(data)),
    getLoginHistory: data => dispatch(getLoginHistory(data))
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  isAuthenticated(),
  withProps({
    title: 'common:account_page-title',
    contentImage: '',
    initialActiveTab: 'profile'
  }),
  withInitialData,
  lifecycle({
    componentWillMount() {
      this.props.getUserData()
    }
  }),
  tabSelectHandler,
  reduxForm({
    destroyOnUnmount: false,
    form: 'account',
    onSubmitFail: errors => scrollToFirstError(errors)
  }),
  accountFormSubmitHandle,
  loadLoginHistoryHandler,
  loadOrdersHistoryHandler,
  pure
)(Account)



// WEBPACK FOOTER //
// ./pages/account.js